( ( $ ) => {

	const ANIMATION_TIME = 300;

	$( '[data-details-tabs]' ).each( function initTabs() {
		const $el = $( this ),
			$toggles = $( '[data-details-tab-toggle]', $el ),
			$contents = $( '[data-details-tab-content]', $el );

		const activateTab = ( $btn ) => {
			const $content = $contents.filter( `[data-details-id="${$btn.attr( 'data-tab-id' )}"]` );
			const $oldContent = $contents.filter( '.active' );
			$btn.attr( 'aria-current', 'true' );
			$toggles.not( $btn ).attr( 'aria-current', 'false' );
			$oldContent.parent().css( 'min-height', `${ $oldContent.height() }px` );
			$content.not( $content ).slideUp( 0 );
			$oldContent.removeClass( 'active' );
			$content.addClass( 'active' ).fadeIn( ANIMATION_TIME );
		}

		$toggles.on( 'click', function toggleTab( event ) {
			const $btn = $( this );
			activateTab( $btn );
			event.preventDefault();
		} );

		$( window ).on( 'load', function initStates() {
			$el.addClass( 'loaded' );
			const $toggle = $toggles.filter( '[aria-current="true"]' );
			activateTab( $toggle );
		} );

	} );

} )( jQuery )